import { render, staticRenderFns } from "./WallOfShame.vue?vue&type=template&id=1dab2e40&"
import script from "./WallOfShame.vue?vue&type=script&lang=js&"
export * from "./WallOfShame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WallOfShame.vue"
export default component.exports